import styled from 'styled-components'

export const Container = styled.div`
  max-width: 640px;
  width: 100%;
  z-index: 1;
  height: 100%;
  max-height: 920px;

  @media (max-width: 700px) {
    min-width: 640px;
    min-height: 734px;
    transform: scale(0.6);
  }
`

export const FakeBlock = styled.div`
  display: block;
  width: 100%;
  height: 64px;
`

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 640px;
  height: 900px;
`

export const ButtonsWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 8px;
`
